import { FC, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { HeaderClients } from "./header-clients";
import { FilterClients } from "./filter-clients";
import { TabClients } from "./tab-clients";
import { ListClients } from "./list-clients";
import { ClientModal } from "./client-modal";
import { ClientProfileModal } from "./client-profile-modal";
import { useClientStore } from "./clients.store";
import { ClientStatus, ClientType } from "~/utils/constants";

type Props = {};

export const ClientManagement: FC<Props> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { filters, setFilters } = useClientStore();

  // Load filters from URL on component mount
  useEffect(() => {
    const searchFromUrl = searchParams.get("search");
    const typeFromUrl = searchParams.get("type") as ClientType | null;
    const pageFromUrl = searchParams.get("page");
    const statusFromUrl = searchParams.get("status") as ClientStatus | null;

    const initialFilters: Record<string, any> = {};

    if (statusFromUrl && Object.values(ClientStatus).includes(statusFromUrl)) {
      initialFilters.status = statusFromUrl;
    }

    if (searchFromUrl) {
      initialFilters.search = searchFromUrl;
    }

    if (typeFromUrl && Object.values(ClientType).includes(typeFromUrl)) {
      initialFilters.type = typeFromUrl;
    }

    if (pageFromUrl && !isNaN(Number(pageFromUrl))) {
      initialFilters.page = Number(pageFromUrl);
    }

    if (Object.keys(initialFilters).length > 0) {
      setFilters(initialFilters);
    }
  }, [searchParams, setFilters]);

  // Update URL when filters change
  useEffect(() => {
    setSearchParams(
      (params) => {
        // Handle search parameter
        if (filters.search) {
          params.set("search", filters.search);
        } else {
          params.delete("search");
        }

        // Handle type parameter
        if (filters.type) {
          params.set("type", filters.type);
        } else {
          params.delete("type");
        }

        // Handle pagination
        if (filters.page && filters.page > 1) {
          params.set("page", String(filters.page));
        } else {
          params.delete("page");
        }

        // Handle status parameter
        if (filters.status) {
          params.set("status", filters.status);
        } else {
          params.delete("status");
        }

        return params;
      },
      { replace: true }
    );
  }, [filters, setSearchParams]);

  return (
    <div className="bg-gray-50">
      <HeaderClients />

      <FilterClients />

      <TabClients />

      <ListClients />

      <ClientModal />
      <ClientProfileModal />
    </div>
  );
};
